import classname from 'classnames';
import React from 'react';

import FeatureBlock from '../../FeatureBlock/FeatureBlock';
import Testimonial from '../../Testimonial/Testimonial';
import HtmlContent from '../HtmlContent/HtmlContent';
import Image from '../Image/Image';
import Video from '../Video/Video';
import * as styles from './Content.module.scss';

const Content = ({ items, allowBreakout, hasLead = true }) => {
  return (
    <>
      {items?.map((item, index) => {
        if (item.fieldGroupName?.includes('LayoutWysiwyg')) {
          return (
            <HtmlContent
              className={classname(styles.content, {
                [ styles.hasLead ]: hasLead,
              })}
              content={item.wysiwyg}
              key={index}
            />
          );
        }

        if (item.fieldGroupName?.includes('LayoutHtml')) {
          return (
            <HtmlContent
              className={classname(styles.content, {
                [ styles.hasLead ]: hasLead,
              })}
              content={item.html}
              key={index}
            />
          );
        }

        if (item.fieldGroupName?.includes('LayoutImage')) {
          return (
            <Image isBreakout={allowBreakout} image={item.image} key={index} />
          );
        }

        if (item.fieldGroupName?.includes('LayoutVideo')) {
          return <Video url={item.video} caption={item.caption} key={index} />;
        }

        if (item.fieldGroupName?.includes('LayoutTestimonial')) {
          return <Testimonial {...item.testimonial} key={index} />;
        }

        if (item.fieldGroupName?.includes('LayoutNavigationCard')) {
          const { link, ...other } = item;
          return <FeatureBlock {...other} path={link.url} key={index} />;
        }

        return null;
      })}
    </>
  );
};

export default Content;
